import { dateOnlyOf, orgCalendarDate } from '@/lib/utils/custom-date/custom-date';
import { getOrganizationTimeZone } from '@/lib/utils/custom-date/org-time-zone';

/**
 * Whether a leave has not started yet: its first day is today or later, where today is the employee's
 * day in the organization's time zone (not the device's or the UTC day).
 */
export const isLeaveNotStarted = (
  startDate: string | null | undefined,
  now: Date = new Date(),
  timeZone: string = getOrganizationTimeZone()
): boolean => {
  const firstDay = dateOnlyOf(startDate, timeZone);
  return Boolean(firstDay) && firstDay >= orgCalendarDate(now.toISOString(), timeZone);
};

/**
 * The withdraw rule of LEAVE_REQUEST_WITHDRAW: the employee's own Pending or Approved leave, until the end
 * of its first day in the organization's zone.
 */
export const canWithdrawLeave = (
  leave: { Status: string; StartDate: string | null | undefined },
  now: Date = new Date(),
  timeZone: string = getOrganizationTimeZone()
): boolean =>
  (leave.Status === 'Pending' || leave.Status === 'Approved') &&
  isLeaveNotStarted(leave.StartDate, now, timeZone);
